export default "__VITE_ASSET__bd2b91b5__"